<p>{{ 'license_intro' | translate }}</p>

<!-- available credits -->
<ion-grid class="ion-no-margin ion-margin-top ion-no-padding">
  <ion-row class="ion-margin-vertical ion-no-padding">
    <ion-col class="credits ion-padding" size-xs="12" size-sm="12" size-md="12">
      <ion-grid>
        <ion-row>
          @if (installerAccessUntil()) {
            <ion-col>
              <p>
                <b>{{ 'installation_until' | translate }}</b>
              </p>
              @if (showUnlimited()) {
                <h2 class="smaller">
                  {{ 'license_unlimited' | translate }}
                </h2>
              } @else {
                <h2 class="smaller">{{ installerAccessUntil() | date }}</h2>
              }
            </ion-col>
          }
          <ion-col>
            <p>
              <b
                >{{ 'license_currentCredits' | translate }}
                {{ currentCreditsName() | translate }}s</b
              >
            </p>
            <h2 [ngClass]="{ smaller: installerAccessUntil() !== null }">
              {{ currentCredits()
              }}<span> {{ currentCreditsName() | translate }}s</span>
            </h2>
          </ion-col>
          <ion-col>&nbsp;</ion-col>
        </ion-row>
      </ion-grid>

      <ion-button
        (click)="
          showPaymentProductsToBuy(
            'installation_buyCredits',
            'installation_buyCreditsInfo'
          )
        "
      >
        <small
          >{{ 'products_topUp' | translate }}
          {{ currentCreditsName() | translate }}s</small
        >
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>

@if (!showUnlimited()) {
  <ng-container>
    <ion-label class="panel-header-text" color="dark"
      >{{ 'license_options' | translate }}
    </ion-label>

    <!-- product overview -->
    <ion-grid class="products ion-no-margin ion-margin-vertical ion-no-padding">
      <ion-row class="ion-no-padding">
        @for (
          product of productsToBuyWithPaymentProducts();
          track product.uid
        ) {
          <ion-col
            (click)="onProductSelected(product)"
            class="product"
            [ngClass]="{ active: product.isSelected }"
            size-xs="12"
            size-sm="12"
            size-md="6"
          >
            <div class="ion-margin ion-padding">
              <h3>{{ product.name | translate }}</h3>
              <h2>
                {{ product.pricePaymentProduct
                }}<span> {{ product.unit ?? '' | translate }}s</span>
              </h2>
              <p [innerHTML]="product.info ?? '' | translate"></p>
            </div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>

    <!-- button to submit selection -->
    <ion-button
      [disabled]="selectedProduct === null"
      type="submit"
      class="ion-float-right"
      color="primary"
      (click)="submitProduct()"
    >
      <small>{{ btnText() | translate }}</small>
    </ion-button>
  </ng-container>
}
